module.exports = __webpack_public_path__ + "static/media/news-vanguard.e1ec37a4.jpg";